import React, { useRef, useState } from 'react';
import { sortOrderObj } from '../../../helpers/data';

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
    const [ascSort, setAscSort] = useState('inactive');
    const [descSort, setDescSort] = useState('inactive');
    const [noSort, setNoSort] = useState('inactive');
    const [hideUpArrow,setHideUpArrow] = useState('');
    const [hideDownArrow,setHideDownArrow] = useState('')
    const refButton = useRef(null);

    const onMenuClicked = () => {
        props.showColumnMenu(refButton.current);
    };

    const onSortChanged = (order) => {
        if(order?.toLowerCase() === sortOrderObj.downArrow?.toLowerCase()) {
            setHideUpArrow("hide-up-arrow");
            setHideDownArrow("");
        } else if(order?.toLowerCase() === sortOrderObj.upArrow?.toLowerCase()){
            setHideUpArrow("");
            setHideDownArrow("hide-down-arrow");
        } else if(order === ""){
            setHideUpArrow("");
            setHideDownArrow("");
        };
        const isAscending = order === 'Asc';
        const isDescending = order === 'Desc';
        setAscSort(isAscending ? 'active' : 'inactive');
        setDescSort(isDescending ? 'active' : 'inactive');
        setNoSort(
            !isAscending && !isDescending
                ? 'active'
                : 'inactive'
        );
    };

    const getFieldName = (displayName) => {
        return props.headers.find(header => header.name.toLowerCase() === displayName.toLowerCase()).field;
    }
    const onSortRequested = (order) => {
        props.sort(order, getFieldName(props.displayName));
        onSortChanged(order);
    };

    let menu = null;
    if (props.enableMenu) {
        menu = (
            <div
                ref={refButton}
                className="customHeaderMenuButton"
                onClick={() => onMenuClicked()}
            >
                <i className={`fa fa-bars`}></i>
            </div>
        );
    }

    let sort = null;
    if (props.enableSorting) {
        sort = (
            <div style={{ display: 'inline-block' }}>
                 <div
                    onClick={(event) => onSortRequested('Desc', event)}
                    onTouchEnd={(event) => onSortRequested('Desc', event)}
                    className={`customSortUpLabel ${descSort} ${hideUpArrow}`}
                >
                    <i class="fa fa-arrow-up"></i>
                </div>
                <div
                    onClick={(event) => onSortRequested('Asc', event)}
                    onTouchEnd={(event) => onSortRequested('Asc', event)}
                    className={`customSortDownLabel ${ascSort} ${hideDownArrow}`}
                >
                    <i class="fa fa-arrow-down"></i>
                </div>
                <div
                    onClick={(event) => onSortRequested('', event)}
                    onTouchEnd={(event) => onSortRequested('', event)}
                    className={`customSortRemoveLabel ${noSort}`}
                >
                    <i class="fa fa-close"></i>
                </div>
            </div>
        );
    }

    const getIcons = (displayName) => {
        const data = props.headers.find(header => header.name.toLowerCase() === displayName.toLowerCase());
        return data && data.icon ? data.icon : ''
    }

    const getClassName = (displayName) => {
        const data = props.headers.find(header => header.name.toLowerCase() === displayName.toLowerCase());
        return data && data.className ? data.className : ''
    }

    const getColor = (displayName) => {
        const data = props.headers.find(header => header.name.toLowerCase() === displayName.toLowerCase());
        return data && data.color ? data.color : ''
    }


    const showIcons = name => {
        return <i className={`${getIcons(name)} ${getClassName(name)}`} style={{ fontSize: name === 'Candidate' ? '1rem' : '1.15rem', color: `${getColor(name)}` }} />
    }

    return (
        <div>
            {menu}
            <div className="customHeaderLabel">
                {
                    getIcons(props.displayName) ? showIcons(props.displayName) : props.displayName
                }
                {/* {console.log(getIcons(props.displayName), '====>>>>')} */}
            </div>
            {sort}
        </div>
    );
};

// {props.displayName} {console.log(getIcons(props.displayName), '====>>>>')}
